import { select } from "d3-selection";

export default selector => {
  let data = [];

  const $ = () => {
    const selection = select(selector);

    const container = selection
      .append("div")
      .attr("class", "step vh-100 w-100 with-navbar")
      .style(
        "background-image",
        "url(http://www.optics-project.eu/wp-content/uploads/2019/03/sky_intro_D.jpg)"
      )
      .append("div")
      .attr("class", "container h-100 d-flex flex-column");
    container
      .append("div")
      .attr(
        "class",
        "row align-items-center justify-content-center flex-grow-0 flex-shrink-0"
      )
      .append("div")
      .attr("class", "col-8")
      .append("p")
      .attr("class", "text-center text-step")
      .text("How can we help?");

    const stakeholdersRow = container
      .append("div")
      .attr(
        "class",
        "row align-items-center justify-content-center flex-grow-1 flex-shrink-1"
      );

    const sh = stakeholdersRow
      .selectAll(".homeStakeholders")
      .data(data, function(d) {
        return d.step;
      });

    const card = sh
      .enter()
      .append("div")
      .attr("class", "col-12 col-md-4 h-60")
      .append("div")
      .attr("class", "homeStakeholders");

    card
      .append("p")
      .attr("class", "stakeholder")
      .text(function(d) {
        return d.stakeholder;
      });

    card
      .append("img")
      .attr("src", function(d) {
        return d.img_url;
      })
      .attr("class", "img-fluid");

    card
      .append("p")
      .attr("class", "text-center stakeholder-question")
      .text(function(d) {
        return d.question;
      });
  };

  $.data = _ => {
    data = _;
    return $;
  };

  return $;
};
